module.exports = __webpack_public_path__ + "static/media/code.ee494b61.svg";